import React from 'react';
import { FuelInteractiveIcon, FuelTypography } from '@frete.com/fuel-react';
import { useNavigate } from 'react-router-dom';
import { Container } from './styled';
import { FREIGHT_LISTING, RISK_LIST } from '@/constants';
import { useFreight, useGlobal, useTracker } from '@/hooks';
import { useAppContext } from '@/context';

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { freightId, navigateWithFreight } = useFreight();
  const tracker = useTracker();
  const { state } = useAppContext();
  const { isShowNewHorizontal } = useGlobal();

  const onHandleCloseClick = () => {
    tracker.dispatchWithUserData('risk_management_form_exit_clicked', {
      trucker: { id: state.risk.data.trucker.personId },
    });
    if (Boolean(freightId)) navigateWithFreight(FREIGHT_LISTING);
    else navigate(RISK_LIST);
  };

  return (
    <Container>
      {!isShowNewHorizontal && <FuelInteractiveIcon icon="close" size="large" onClick={onHandleCloseClick} />}
      <FuelTypography size="heading-md" color="neutral-strong" weight="bold" tag="h1">
        Cadastrar motorista na GR
      </FuelTypography>
    </Container>
  );
};
